export const Users = () => {
  return (
    <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5022 15V11.8996C10.5022 11.1306 10.1967 10.393 9.65292 9.84926C9.10915 9.30549 8.37163 9 7.60262 9H3.89956C3.13055 9 2.39304 9.30549 1.84926 9.84926C1.30549 10.393 1 11.1306 1 11.8996V15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15V12.8996C17 12.1306 16.6945 11.393 16.1507 10.8493C15.607 10.3055 14.769 10 14 10L12.9258 10H12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.78628 6.79913C7.38767 6.79913 8.68584 5.50095 8.68584 3.89956C8.68584 2.29818 7.38767 1 5.78628 1C4.1849 1 2.88672 2.29818 2.88672 3.89956C2.88672 5.50095 4.1849 6.79913 5.78628 6.79913Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 8C14.8807 8 16 6.88071 16 5.5C16 4.11929 14.8807 3 13.5 3C12.1193 3 11 4.11929 11 5.5C11 6.88071 12.1193 8 13.5 8Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
